<template>
  <div class="mt-5">
    <!--  Button Tab -->
    <button-tab class="px-3" v-model="actionType">
      <button-tab-item>{{ $t('auth.register.register') }}</button-tab-item>
      <button-tab-item>{{ $t('auth.login.login') }}</button-tab-item>
    </button-tab>
    <!--  Panel -->
    <div>
      <group :title="$t('auth.register.postfix')">
        <selector v-if="actionType == 0" direction="rtl" :placeholder="$t('auth.register.regionPlaceholder')" v-model="regionResult" :title="$t('auth.register.region')" :options="regionList" @on-change="changeRegion"></selector>
        <x-input v-if="actionType == 0" text-align="right" v-model="telephone" :title="$t('auth.register.telephone')" :placeholder="telephoneMask.mask" :mask="telephoneMask.mask" :max="telephoneMask.max" :min="telephoneMask.min" required type="tel" :show-clear="false" @on-blur="onBlur" placeholder-align="right"></x-input>
        <x-input v-else text-align="right" v-model="loginUsername" :title="$t('auth.login.username')" :placeholder="$t('auth.login.usernamePlaceholder')" required type="text" :show-clear="false" @on-blur="onBlur" placeholder-align="right"></x-input>
        <x-input text-align="right" v-model="password" :title="$t('auth.register.password')" required type="password" :show-clear="false" @on-blur="onBlur" placeholder-align="right" :min='6' :max='20'></x-input>
        <x-input v-if="actionType == 0" text-align="right" v-model="password2" required :equal-with="password" :title="$t('auth.register.confirmPassword')" type="password" :show-clear="false" @on-blur="onBlur" placeholder-align="right" :min='6' :max='20'></x-input>
      </group>
      <!-- Referral Code -->
      <group v-if="actionType == 0" :title="$t('auth.register.referralCodeHint')">
        <x-input :max="10" text-align="right" v-model="referralCode" :title="$t('auth.register.referralCode')" class="weui-vcode" required>
        </x-input>
      </group>
      <!-- Terms and Condiction -->
      <div v-if="actionType == 0" class="row mx-3 mt-3 text-center">
        <b-form-checkbox v-model="termsCheck"></b-form-checkbox>
        <span>
          {{$t('auth.register.terms.labelPrefix')}} <span @click="openModal('privacy')" class="termsText">{{$t('auth.register.terms.privacy')}}</span> {{$t('auth.register.terms.and')}} <span @click="openModal('terms')" class="termsText">{{$t('auth.register.terms.userTerms')}}</span> 
        </span>
      </div>
      <div class="my-5 px-3">
        <x-button type="primary" @click.native="onAction()">{{actionText}}</x-button>
      </div >
      <div v-if="actionType == 1" class="d-flex justify-content-center">
        <span class="termsText" @click="$router.replace('/forgetPassword')">{{$t('auth.login.forgetPassword')}}</span>
      </div>
    </div>
    <loading v-model="showLoading" :text="loadingText"></loading>
    <div v-transfer-dom>
      <alert v-model="showAlert" :title="$t('auth.register.actionFail')" @on-show="onShow" @on-hide="onHide" :button-text="$t('general.confirm')"> {{ alertText}}</alert>
    </div>
    <div v-transfer-dom>
      <popup v-model="showVerification" height="270px" is-transparent>
        <div style="width: 100%;background-color:#fff;height:250px;margin:0 auto;border-radius:5px;padding-top:10px;">
          <!-- Verification Code -->
          <group v-if="actionType == 0" :title="$t('auth.register.veriCodeHint')">
            <x-input required type='tel' :max="6" text-align="right" v-model="veriCode" :title="$t('auth.register.smsVeriCode')" class="weui-vcode">
              <x-button v-if="!isSending" slot="right" type="primary" mini @click.native="sendVeriCode()">{{$t('auth.register.sendVeriCode')}}</x-button>
              <x-button v-else slot="right" type="default" disabled mini>{{sendingText}}</x-button>
            </x-input>
          </group>
          <div style="padding:20px 15px;">
            <x-button type="primary" @click.native="verifyMobile()">{{$t('general.confirm')}}</x-button>
            <x-button @click.native="showVerification = false">{{$t('general.cancel')}}</x-button>
          </div>
        </div>
      </popup>
    </div>
    <div v-transfer-dom>
      <confirm :cancel-text="$t('kol.header.cancel')" :confirm-text="$t('kol.header.confirm')" v-model="showConfirm" :title="confirmText" @on-confirm="registerAction">
      </confirm>
    </div>
    <UserTerms ref="termsRef"></UserTerms>
    <Privacy ref="privacyRef"></Privacy>

  </div>
</template>
<script type="text/javascript">
import UserTerms from './UserTerms'
import Privacy from './Privacy'
import { FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton } from '@/components'
import { mapGetters } from 'vuex'
import { Confirm, Popup, TransferDom, ButtonTab, ButtonTabItem, XInput, Group, Selector, Alert, Loading } from 'vux'
import $ from 'jquery'
import Vue from 'vue'
import Cookies from 'js-cookie'
var timer;
const regionNum = {
  cn: '+86',
  hk: '+852',
  mo: '+853'
}

export default {
  name: 'Login',
  directives: {
    TransferDom
  },
  components: {
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
    ButtonTab,
    ButtonTabItem,
    XInput,
    Group,
    Selector,
    Alert,
    Loading,
    Popup,
    Confirm,
    UserTerms,
    Privacy
  },
  props: {},
  data() {
    return {
      termsCheck:false,
      showConfirm: false,
      confirmText: '',
      showAlert: false,
      alertText: this.$t('auth.register.alertMsg.required'),
      showLoading: false,
      showVerification: false,
      loadingText: this.$t('kol.loadingMsg'),
      actionType: 0, // 0 register; 1 login
      regionResult: 'hk',
      telephone: '',
      loginUsername: '',
      password: '',
      password2: '',
      veriCode: '',
      isSending: false,
      sendingText: '',
      referralCode: 'super102',
      regionList: [
        // { key: '', value: this.$t('auth.register.regionPlaceholder'), mask:'', max:0, min:15 },
        { key: 'cn', value: this.$t('kol.region.cn') + ' ' + regionNum.cn, mask: '999 9999 9999', max: 13, min: 13 },
        { key: 'hk', value: this.$t('kol.region.hk') + ' ' + regionNum.hk, mask: '9999 9999', max: 9, min: 9 },
        // { key: 'mo', value: this.$t('kol.region.mo') + ' ' + regionNum.mo, mask: '9999 9999', max: 9, min: 9 },
      ],

      // showVerification:true,
      // regionResult:'hk',
      // telephone: '9063 7178',
      // password: '123456',
      // password2: '123456',


    }
  },
  created() {
    document.title = `${this.$t('auth.register.register')}/${this.$t('auth.login.login')} - ${this.$t('kol.title')}`;
    this.updateReferralCode();
    this.updateActionType();
    // this.$store.commit('setSearchCategory', { categoryID: '0' });
    let token = Cookies.get('token');
    if(!token) return;
    let param = {
        count: 10,
        orderby: 'ID',
        categoryID:'8',
      };
    this.$store.dispatch('Product/getFullProductList',param).then((json)=>{
      if(this.isRedirect !== 'true'){
        this.$router.replace('/product/list');
      }
    });

  },
  mounted() {

  },
  watch: {
    actionType() {
      this.telephone = '';
      this.password = '';
      this.password2 = '';
    }
  },
  computed: {
    ...mapGetters([
      'getRouteStatus',
    ]),

    username() {
      return this.telephone.replace(/\s/g, '');
    },
    actionText() {
      let label = (this.actionType == 0) ? this.$t('auth.register.register') : this.$t('auth.login.login');
      return label;
    },
    telephoneMask() {
      let selectedRegion = {};

      if (!this.regionResult) {
        selectedRegion.mask = '';
        selectedRegion.max = 15;
        selectedRegion.min = 0;
        selectedRegion.placeholder = region.mask;
        return selectedRegion;
      }

      $.each(this.regionList, (index, region) => {
        if (region.key == this.regionResult) {
          selectedRegion.mask = region.mask;
          selectedRegion.max = region.max;
          selectedRegion.min = region.min;
          selectedRegion.placeholder = region.mask;
        }
      })

      return selectedRegion;
    },

    formValidation() {
      let result = true;
      if (this.actionType == 0) {
        if ((this.password != this.password2) || (!this.password))
          result = false;
        if (!this.telephone) result = false;
        if (!this.termsCheck) result = false;
      } else {
        if ((!this.loginUsername) || (!this.password))
          result = false;
        // if (!this.termsCheck) result = false;

      }
      return result;
    },
    isRedirect() {
      return Cookies.get('redirect');
    }

  },
  methods: {
    updateActionType() {
      let path = this.$router.currentRoute;
      if ((path.query.type) && (path.query.type == '1')) {

        this.actionType = 1;
        this.telephone = '';
        this.password = '';
      }
    },
    updateReferralCode() {
      let path = this.$router.currentRoute;
      if (path.query.referralCode) {
        this.referralCode = path.query.referralCode;
      }
    },
    getVeriCode() {
      if (!this.username) {
        return "";
      }
      // console.log(this.username);
      let length = this.username.length;
      let telephone = this.username.substring(length - 8, length);
      // console.log(telephone)

      var str = telephone.split("").reverse().join("");
      var subStr = str.substring(0, 6);
      var subStr2 = str.substring(6, 8);
      var number = Number(subStr) + Number(subStr2) * 10101;
      number += 124962;
      str = number + "";
      str = str.substring(0, 6);
      return str;
    },
    changeRegion($event) {
      let lang = $event;
      this.currentRegion = lang;
      // if (lang == 'cn') {
      //   this.setLocale('zh_cn');
      // } else {
      //   this.setLocale('zh_hk');
      // }
      this.setLocale(`zh_${lang}`);
    },
    setLocale(locale) {
      Vue.config.lang = locale
      this.$cookie.set('locale', locale)
      this.$i18n.locale = Vue.config.lang
      // console.log("New locale = " + Vue.config.lang + ": language = " + localeStrings[Vue.config.lang])
    },

    sendVeriCode() {
      // send SMS api
      let sendSMSParams = {
        region: regionNum[this.regionResult],
        verificationCode: this.getVeriCode(),
        username: this.username,
        password: this.password,
        referralCode: this.referralCode,
        alias: '',
      };
      this.$store.dispatch('Auth/registerThenSendCode', sendSMSParams).then((json) => {
        this.smsSuccessResponse();
      });
    },

    registerThenLogin() {
      let registerParam = {
        // region: regionNum[this.regionResult],
        // verificationCode: this.getVeriCode(),
        username: this.username,
        password: this.password,
        referralCode: this.referralCode,
        alias: '',
      };

      let loginParam = {
        username: this.username,
        password: this.password,
      };
      this.loadingText = this.$t('kol.registeringMsg');
      this.showLoading = true;
      this.$store.dispatch('Auth/register', registerParam).then((json) => {
          this.$store.dispatch('Auth/login', loginParam).then((json) => {
              this.showLoading = false;
              this.loginSuccessResponse(json);
            })
            .catch((error) => {
              this.showLoading = false;
            });

        })
        .catch((error) => {
          this.showLoading = false;
        })
    },

    smsSuccessResponse() {
      this.showVerification = true;
      this.isSending = true;
      var timeAmount = 60; // second
      this.sendingText = `${this.$t('auth.register.sent')}(${timeAmount}s)`;
      timer = setInterval(() => {
        timeAmount -= 1;
        this.sendingText = `${this.$t('auth.register.sent')}(${timeAmount}s)`;
        if (timeAmount == 0) {
          clearInterval(timer);
          this.isSending = false;
        }
      }, 1000);
    },
    verifyMobile() {
      if (!this.veriCode) {
        this.showAlert = true;
        return;
      }
      let verifyParams = {
        username: this.username,
        password: this.password,
        verificationCode: this.veriCode
      };
      this.$store.dispatch('Auth/verifyMobileThenLogin', verifyParams)
        .then((json) => {
          // console.log(json)
          this.loginSuccessResponse(json);

        })
    },
    loginSuccessResponse(json) {
      this.axios.defaults.headers.common['Authorization'] = json.data.token;
      this.$router.push('/product/list');
    },

    registerAction() {
      // this.sendVeriCode();
      this.showConfirm = false;
      this.registerThenLogin();
    },

    onAction() { // Register & Login Btn 
      clearInterval(timer);
      if (this.actionType == 0) { // Register Btn 
        if (!this.formValidation) {
          this.showAlert = true;
          return;
        }
        this.confirmText = `${this.$t('auth.register.alertMsg.regConfirmPrefix')} ${this.telephone} ${this.$t('auth.register.alertMsg.regConfirmPostfix')}`;
        this.showConfirm = true;

      } else { // Login Btn
        if (!this.formValidation) {
          this.showAlert = true;
          return;
        }
        let loginParam = {
          username: this.loginUsername,
          password: this.password,
        }
        this.loadingText = this.$t('auth.register.alertMsg.logining');
        this.showLoading = true;
        this.$store.dispatch('Auth/login', loginParam)
          .then((json) => {
            // console.log(json)
            this.showLoading = false;
            this.loginSuccessResponse(json);
          })
          .catch((error) => {
            this.showLoading = false;
          })

      }
    },
    openModal(type){
      switch(type){
        case 'terms':
          this.$refs.termsRef.openModal();
        break;
        case 'privacy':
          this.$refs.privacyRef.openModal();
        break; 
      }
    },
    onChange() {

    },
    onShow() {

    },
    onHide() {

    },
    onBlur() {

    },
    forgetPassword() {
      this.$router.push('/forgetPassword')
    },
    
  },
}

</script>
<style type="text/css">
button.weui-btn_mini {
  padding: 0 0.5rem !important;
  font-size: 14px !important;
  /*line-height: 1.3rem !important;*/
}

.termsText {
  text-decoration: underline;
  color: #20a8d8;
  cursor:pointer;
}

/*.weui-cell__bd.weui-cell__primary{
  max-width: 120px !important; 
}
*/

</style>



// WEBPACK FOOTER //
// src/Auth/components/Login.vue